
import { Vue, Component } from "vue-property-decorator";
import UserAccess from "@/model/User/UserAccess";
import { mapGetters, mapActions } from "vuex";
import IbotechService from "@/services/ibotechService";
import Multiselect from "vue-multiselect";

@Component({
  name: "MissingsRecords",
  components: { Multiselect },
  computed: {
    ...mapGetters(["getMissingRecordsData", "getUserAccess", "isIbotech", "getAllLocationsData"]),
  },
  methods: {
    ...mapActions(["getMissingRecords", "getAllLocations"])
  }
})
export default class MissingRecords extends Vue {
  readonly getUserAccess!: UserAccess;
  private getMissingRecordsData!: Array<object>;
  private getMissingRecords!: Function;

  private getAllLocationsData!: Array<any>;
  private getAllLocations!: Function;

  perPage: number = 30;
  currentPage: number = 1;
  searchInTableFor: string = "";
  filter: string = "";
  loading = false;
  missingRecordsForm = {
    plateNumber: "",
    registrationDate: "",
    registrationTime: "",
    projectId: "" as any,
    notice: ""
  }

  fields: Array<string | any> = [
    {
      key: "selected",
      sortable: false,
      label: this.translateTableLabel('selected')
    },
    {
      key: "registrationTime",
      sortable: false,
      label: this.translateTableLabel('registrationTime')
    },
    {
      key: "vehicle",
      sortable: false,
      label: this.translateTableLabel('plateNumber')
    },
    {
      key: "actions",
      sortable: false,
      label: this.translateTableLabel('actions')
    }
  ];


  created() {

    // Redirect to 404
    if(!this.getUserAccess.AccessIbotech.VIEW.missingRecords) {
      this.$router.push({ name: 'NotFound' });
    }

    this.loading = true;

    // Get - Set Vehicle Data
    this.getMissingRecords().then(() => {
      this.loading = false;
    });

    // Get - Set Location Data
    // -----------------------
    this.getAllLocations().then(() => {
    });

  }


  openModalNewVehicleRecord(data: any) {

    this.resetMissingRecordsValues();
    this.missingRecordsForm.plateNumber = data.item.vehicle;

    // RegisterTime
    // ------------
    const date = new Date(data.item.registrationTime);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-basiert
    const day = String(date.getDate()).padStart(2, '0');

    this.missingRecordsForm.registrationDate = `${year}-${month}-${day}`;
    this.missingRecordsForm.registrationTime = `12:00`;
    this.$bvModal.show('missingRecordsModal');

  }

  async createVehicleRecordManuel() {
    if(this.isVehicleReportFormValid) {

      if(this.missingRecordsForm.registrationTime == "00:00:00" || this.missingRecordsForm.registrationTime == "00:00") {
        this.missingRecordsForm.registrationTime = "00:00:01"
      }

      var registrationTime: any = this.formatLocalDateTime(this.missingRecordsForm.registrationDate, this.missingRecordsForm.registrationTime);

      var data: object = {
        plateNumber: this.missingRecordsForm.plateNumber,
        registrationTime: registrationTime,
        projectId: this.missingRecordsForm.projectId.id,
        notice: this.missingRecordsForm.notice
      }

      const res: any = await IbotechService.putVehicleRecordManuel(data);

      if(res.status === 202) {
        this.success();
        this.closeModal();

        this.loading = true;

        // Get - Set Vehicle Data
        this.getMissingRecords().then(() => {
          this.loading = false;
        });

      } else {
        this.error();
      }
    }

  }

  closeModal() {
    this.$bvModal.hide("missingRecordsModal");
  }

  success() {
    // Success Message
    this.$bvToast.toast((this.$t('ibotech_vehicle.deleteSuccess')).toString(), {
      title: (this.$t('ibotech_vehicle.newVehicleForm.successMessageTitle')).toString(),
      autoHideDelay: 1500,
      variant: 'success'
    });
  }

  error() {
    this.$bvToast.toast((this.$t('ibotech_vehicle.newVehicleForm.errorMessageText')).toString(), {
      title: (this.$t('ibotech_vehicle.newVehicleForm.errorMessageTitle')).toString(),
      autoHideDelay: 1500,
      variant: 'danger'
    })
  }

  formatLocalDateTime(dateString: any, timeString: any) {
    const date = new Date(dateString);
    const timeParts = timeString.split(':');

    // Setzen der Stunden und Minuten
    date.setHours(timeParts[0], timeParts[1]);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind nullbasiert
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }


  get getData() {
    return this.getMissingRecordsData;
  }

  filterActionHandler(filterAction: string) {
    this.filter = filterAction;
  }

  translateTableLabel(label: string) {
    return this.$t(`ibotech_missing_records.tableHeadline.${label}`);
  }

  resetMissingRecordsValues() {
    this.missingRecordsForm = {
      plateNumber: "",
      registrationDate: "",
      registrationTime: "",
      projectId: "",
      notice: ""
    }
  }

  get isVehicleReportFormValid() {
    return Object.entries(this.missingRecordsForm).every(([key, value]) => key === 'notice' || (value !== '' && value !== null));
  }

}
